import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// All album covers in random order
const ALBUM_COVERS = [
  "https://customer-assets.emergentagent.com/job_music-doc-staging/artifacts/eiuspjqh_john-lee-hooker-boogie-chillin.webp",
  "https://customer-assets.emergentagent.com/job_music-doc-staging/artifacts/6gb0rvpu_funkadelic-one-nation-under-a-groove-Cover-Art.webp",
  "https://customer-assets.emergentagent.com/job_music-doc-staging/artifacts/88j2bqbm_c49458f9b169be916afa358cc2d79ff9.webp",
  "https://customer-assets.emergentagent.com/job_music-doc-staging/artifacts/v2aa49x0_the-dramatics-joy-ride-Cover-Art.webp",
  "https://customer-assets.emergentagent.com/job_music-doc-staging/artifacts/rxmtru5r_51akVnl3UHL.webp",
  "https://customer-assets.emergentagent.com/job_music-doc-staging/artifacts/nhchbppw_51HUCvXMnbL.webp",
  "https://customer-assets.emergentagent.com/job_music-doc-staging/artifacts/m17wmzd6_Red-Hot-Chili-Peppers-Freaky-Styley-Music-Performance-Vinyl_ba598404-de9e-4554-bc4c-58a11896bb13.2cc63cf413609cc48de5f455a347b2bf.webp",
  "https://customer-assets.emergentagent.com/job_music-doc-staging/artifacts/bag2nvfe_OC0xMTQwLmpwZWc.webp",
];

// Standardized text height for all screens
const TEXT_HEIGHT = "min-h-[200px] md:min-h-[250px]";

const TextBlock = ({ overline, text, refProp }) => {
  const { scrollYProgress } = useScroll({
    target: refProp,
    offset: ["start 0.9", "end 0.1"],
  });

  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);

  return (
    <motion.div
      ref={refProp}
      className={`${TEXT_HEIGHT} flex items-center justify-center px-6 sm:px-12 md:px-24 py-8`}
      style={{ opacity }}
    >
      <div className="w-full max-w-3xl text-center">
        <span className="font-mono text-[10px] sm:text-xs tracking-[0.2em] text-[#888888] uppercase block mb-4 sm:mb-6">
          {overline}
        </span>
        <p className="font-heading text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light tracking-tight leading-relaxed text-[#F5F5F0]">
          {text}
        </p>
      </div>
    </motion.div>
  );
};

const LegendsSection = () => {
  const legendsRef = useRef(null);
  const raceRef = useRef(null);
  
  const { scrollYProgress: legendsProgress } = useScroll({
    target: legendsRef,
    offset: ["start 0.9", "end 0.1"],
  });

  const legendsOpacity = useTransform(legendsProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);

  // Duplicate albums for seamless loop
  const allAlbums = [...ALBUM_COVERS, ...ALBUM_COVERS];

  return (
    <section className="bg-[#050505]" data-testid="legends-section">
      {/* The Legends Text */}
      <motion.div
        ref={legendsRef}
        className={`${TEXT_HEIGHT} flex items-center justify-center px-6 sm:px-12 md:px-24 py-8 -mt-[5vh]`}
        style={{ opacity: legendsOpacity }}
      >
        <div className="w-full max-w-3xl text-center">
          <span className="font-mono text-[10px] sm:text-xs tracking-[0.2em] text-[#888888] uppercase block mb-4 sm:mb-6">
            The Legends
          </span>
          <p className="font-heading text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light tracking-tight leading-relaxed text-[#F5F5F0]">
            Miles Davis. John Lee Hooker. Aretha Franklin. Anita Baker. George Clinton. Bootsy Collins. The Dramatics. The echoes of greatness still lives within these walls.
          </p>
        </div>
      </motion.div>

      {/* Album Carousel */}
      <div className="album-carousel-section py-6 sm:py-8 overflow-hidden" data-testid="album-carousel">
        <div className="album-carousel-track">
          {allAlbums.map((album, index) => (
            <div key={index} className="album-item">
              <img
                src={album}
                alt={`Album cover ${(index % ALBUM_COVERS.length) + 1}`}
                className="album-cover"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      {/* A Race Against Time Text */}
      <TextBlock
        refProp={raceRef}
        overline="A Race Against Time"
        text="Modern development threatens the studio's existence. Time is running out."
      />
    </section>
  );
};

export default LegendsSection;
